import { Menu, Badge, NumberInput, Button, Stack } from '@mantine/core';
import { useModals } from '@mantine/modals';
import { FormEvent, useState } from 'react';
import { TrashX, Tallymarks } from 'tabler-icons-react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { settingsChanged } from '../../settings/settingsSlice';
import { queueCleared, selectClipLimit } from '../clipQueueSlice';

function ClipLimitModal({ onSubmit }: { onSubmit: () => void }) {
  const dispatch = useAppDispatch();
  const clipLimit = useAppSelector(selectClipLimit);
  const [value, setValue] = useState(clipLimit);

  const submit = (event: FormEvent<HTMLFormElement>) => {
    dispatch(settingsChanged({ clipLimit: value || null }));
    onSubmit();

    event.preventDefault();
  };

  return (
    <form onSubmit={submit}>
      <Stack>
        <NumberInput
          placeholder="Limite de clipes"
          description={
            <>
              Número máximo de clipes na fila. Após isso, novos clipes não serão aceitos, clipes atuais podem ser impulsionados
              para o topo da fila. Você pode <em>Pular</em> um clipe ao invés de usar <em>Próximo</em> para liberar um espaço.
              <br />
              Deixe vazio ou 0 para desabilitar.
            </>
          }
          min={0}
          step={1}
          value={value ?? undefined}
          onChange={(val) => setValue(val)}
        />
        <Button type="submit">Salvar</Button>
      </Stack>
    </form>
  );
}

function QueueQuickMenu() {
  const modals = useModals();
  const dispatch = useAppDispatch();
  const clipLimit = useAppSelector(selectClipLimit);

  const openClipLimitModal = () => {
    const id = modals.openModal({
      title: 'Definir limite de clipes',
      children: <ClipLimitModal onSubmit={() => modals.closeModal(id)} />,
    });
  };

  return (
    <>
      <Menu>
        <Menu.Item
          icon={<Tallymarks size={14} />}
          rightSection={<Badge color="indigo">{clipLimit ?? 'desligado'}</Badge>}
          onClick={() => openClipLimitModal()}
        >
          Definir limite da fila
        </Menu.Item>
        <Menu.Item icon={<TrashX size={14} />} color="red" onClick={() => dispatch(queueCleared())}>
          Limpar fila
        </Menu.Item>
      </Menu>
    </>
  );
}

export default QueueQuickMenu;
